/**
 * Resolved once here rather than imported from @calcom/lib/constants, because this module is loaded
 * from next-i18next.config.js (CommonJS) and must stay free of workspace dependencies.
 * Keep the fallback in sync with APP_NAME in packages/lib/constants.ts.
 */
const process = require("node:process");

const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME || "Termine123";

const BOOKING_DOMAIN = (
  process.env.NEXT_PUBLIC_WEBSITE_URL ||
  process.env.NEXT_PUBLIC_WEBAPP_URL ||
  "termine123.de"
)
  .replace(/^https?:\/\//, "")
  .replace(/\/$/, "");

/**
 * Injected into every i18next instance so that these resolve even when a call site
 * forgets to pass them explicitly.
 */
const defaultInterpolationVariables = { appName: APP_NAME, bookingDomain: BOOKING_DOMAIN };

module.exports = { APP_NAME, BOOKING_DOMAIN, defaultInterpolationVariables };
